module.exports = __webpack_public_path__ + "static/pakmaya-lansman-aa18bb575cfb14796f27ec17ca6446fe.png";